import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.lightRed || '#FEE2E2'};
`;

export const Title = styled(Typography)`
  font-size: 1.8rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.red || '#DC2626'};
`;

export const SummaryText = styled(Typography)`
  text-align: center;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.greyDark};
  margin-bottom: 0.5rem;
`;

export const TabsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
`;

export const TabItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background-color: ${({ theme }) => theme.colors.greyLight || '#F9FAFB'};
  border: 1px solid ${({ theme }) => theme.colors.greySilver || '#E5E7EB'};
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueSoft || '#EFF6FF'};
    border-color: ${({ theme }) => theme.colors.primary || '#3B82F6'};
  }
`;

export const TabName = styled(Typography)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
`;

export const ErrorBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  background-color: ${({ theme }) => theme.colors.red || '#DC2626'};
  color: white;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const ArrowIcon = styled.span`
  color: ${({ theme }) => theme.colors.greyDark || '#6B7280'};
  font-size: 1.25rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;
